import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cx } from "@emotion/css";
import { Icon } from "../icon";
import { Text } from "../text";
export const DropdownSelectText = ({ bigger, outline, isOpened, label, iconPosition, }) => {
    const iconObj = _jsx(Icon, { name: isOpened ? "up" : "down", size: 10 });
    return (_jsxs("button", { className: cx("button", { outline, big: bigger }), type: "button", children: [iconPosition === "before" && iconObj, _jsx(Text, { children: label }), iconPosition === "after" && iconObj] }));
};
DropdownSelectText.defaultProps = {
    bigger: false,
    outline: false,
    isOpened: false,
    iconPosition: "after",
};
